import { IThunderboltEntry } from '@wix/editor-elements-types';

const entry: IThunderboltEntry = {
  loadComponent: hostAPI => {
    hostAPI.registerComponent('TPA3DGallery', () => {
      return Promise.all([
        import('./viewer/TPA3DGallery' /* webpackChunkName: "TPA3DGallery" */),
        import(
          '../TPAGallery/viewer/TPAGallery.controller' /* webpackChunkName: "TPA3DGallery" */
        ),
      ]).then(([componentModule, controllerModule]) => {
        return {
          component: componentModule.default,
          controller: controllerModule.default,
        };
      });
    });
  },
};

export default entry;
